import React, {useState} from "react";
import { useSelector } from "react-redux";
/**Ant-design */
import {Row, Col, Modal} from "antd";
/* Css */
import './ConsultaTotalVacantes.css';

export const ConsultaTotalVacantesComponent = () => {

    /* Store Redux */
    const { listaVacantes } = useSelector((state) => state.consultaVacantes);

    /* States */
    const [isModalCargoVisible, setIsModalCargoVisible] = useState(false);
    const [isModalPlazaVisible, setIsModalPlazaVisible] = useState(false);
    

    const totalVacantes = ()=> {
        let total = 0;

        if (listaVacantes != null) {
        total = listaVacantes.length;
        }

        return total;
    }

    const openOrCloseModalCargo = ()=> {
        setIsModalCargoVisible(!isModalCargoVisible);
    };

    const openOrCloseModalPlaza = ()=> {
        setIsModalPlazaVisible(!isModalPlazaVisible);
    };

    return ( 
        <>
            <div className="mainConsultaTotalVacantes">
                <div className="layout-content-public" style={{paddingBottom: "20px"}}>
                    <Row>
                        <Col xs={{ span: 24}} md={{span: 9}} lg={{span: 7}} xl={{span: 6}} xxl={{span: 4}} className="txt-num-vacantes">
                            Total de cargos/puestos: {totalVacantes()}
                        </Col>
                        <Col xs={{ span: 12}} md={{span: 6}} lg={{span: 5}} xl={{span: 4}} xxl={{span: 3}}>
                            <span
                            className="linkTotalvacantes"
                            onClick={openOrCloseModalCargo}
                            >
                                ¿Qué es un cargo?
                            </span>
                        </Col>
                        <Col xs={{ span: 12}} md={{span: 6}} lg={{span: 5}} xl={{span: 4}} xxl={{span: 3}}>
                            <span
                            className="linkTotalvacantes"
                            onClick={openOrCloseModalPlaza}
                            >
                                ¿Qué es un puesto?
                            </span>
                        </Col>
                    </Row>
                </div>

                {/* Modal Cargo */}
                <Modal
                title={
                    <div className="modalConsultaVacantesHeader">
                    Cargo
                    </div>
                }
                visible={isModalCargoVisible}
                onCancel={openOrCloseModalCargo}
                keyboard={false}
                maskClosable={false}
                width={500}
                footer={null}
                >
                    <div className="modalConsultaVacantesTitle">
                        ¿Qué es un cargo?
                    </div>
                    <div className="modalConsultaVacantesBody">
                        Plazas de cargos con función ejecutiva con atribuciones de dirección,
                        mando y supervisión identificados en el Catálogo de Cargos y Puestos
                        del Servicio Profesional Electoral Nacional para los sistemas del
                        Instituto y de los OPLE.
                    </div>
                </Modal>
                {/* Modal Puesto*/}
                <Modal
                title={
                    <div className="modalConsultaVacantesHeader">
                        Puesto
                    </div>
                }
                visible={isModalPlazaVisible}
                onCancel={openOrCloseModalPlaza}
                keyboard={false}
                maskClosable={false}
                width={500}
                footer={null}
                >

                    <div className="modalConsultaVacantesTitle">
                        ¿Qué es un puesto?
                    </div>
                    <div className="modalConsultaVacantesBody">
                        Plazas de puestos con función técnica especializadas identificados en
                        el Catálogo de Cargos y Puestos del Servicio Profesional Electoral
                        Nacional para los sistemas del Instituto y de los OPLE.
                    </div>
                    <div className="modalConsultaVacantesTitle">
                        ¿Qué es una plaza?
                    </div>
                    <div className="modalConsultaVacantesBody">
                        Es la posición que respalda un cargo o puesto en la estructura
                        ocupacional o plantilla que puede ser ocupada solo por una persona y
                        que tiene una adscripción determinada.
                    </div>
                </Modal>
            </div>
        </>
    );
}
 